import { ia } from 'lib/helpers/utility';

export const renderType = ({ primary, secondary, tertiary } = {}) => {
  const typeMap = { primary: 'Primary', secondary: 'Secondary', tertiary: 'Tertiary' };

  return (
    Object.entries({ primary, secondary, tertiary })
      .filter(([_, value]) => ia(value))
      .map(([key]) => typeMap[key])
      .join(', ') || '-'
  );
};
